import { render } from "./Stars.vue?vue&type=template&id=139148bc&scoped=true"
import script from "./Stars.vue?vue&type=script&lang=js"
export * from "./Stars.vue?vue&type=script&lang=js"

import "./Stars.vue?vue&type=style&index=0&id=139148bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\v-tax-chauffeurs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139148bc"]])

export default __exports__